import { Autocomplete, TextField } from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { AutocompleteType } from "../../common/types/autoComplete";
import { selectActiveOrderTemplates } from "../customer/orderTemplatesSlice";
import { NEW_ORDER_COLUMN_WIDTHS } from "./constants";
import { autoCompleteDefaultValue } from "./orderTypes";
import { OrderFormShortRowGridItem } from "./styles";

const OrderTemplateField = ({
  isHidden,
  value,
  orderTemplateDisabled,
  onChange,
  isFirstRow,
}: any) => {
  const localized = useAppSelector((state) => state.localized);
  const orderTemplates = useAppSelector(selectActiveOrderTemplates);

  const orderTemplateOptions = orderTemplates.map((orderTemplate) => {
    return {
      ...orderTemplate,
      name: orderTemplate.name,
      id: orderTemplate.id,
      skills: orderTemplate.skills.map((id) => ({
        name: localized.skill[id],
        id: id,
      })),
      certificates: orderTemplate.certificates.map((id) => ({
        name: localized.certificate[id],
        id: id,
      })),
      languages: orderTemplate.languages.map((language) => ({
        id: language.languageCode, //TODO: use id when you have it?
        languageCode: language.languageCode,
        skillLevel: language.skillLevel,
      })),
      trainings: orderTemplate.trainings?.map((id) => ({
        name: localized.training[id],
        id: id,
      })),
      tes: {
        id: orderTemplate.tesId,
        name: localized.tes[orderTemplate.tesId],
      },
      ...(orderTemplate.salaryLimit && {
        salaryLimit: orderTemplate.salaryLimit,
      }),
      ...(orderTemplate.periodStartDate && {
        periodStartDate: new Date(orderTemplate.periodStartDate),
      }),
    };
  });

  return (
    <OrderFormShortRowGridItem
      item
      width={NEW_ORDER_COLUMN_WIDTHS.orderTemplate}
      xs
    >
      <Autocomplete
        sx={{
          backgroundColor: "rgba(249, 249, 250, 0.6)",
          visibility: isHidden ? "hidden" : "visible",
          "& :hover .MuiAutocomplete-input, & .Mui-focused .MuiAutocomplete-input":
            { minWidth: "30px" },
        }}
        componentsProps={{ paper: { sx: { wordBreak: "break-all" } } }}
        value={value}
        disableClearable
        getOptionLabel={(option) => option.name}
        options={orderTemplateOptions.sort((a, b) =>
          a.name.localeCompare(b.name),
        )}
        disabled={orderTemplateDisabled}
        renderInput={(params) => (
          <TextField {...params} size="small" name="orderTemplate" />
        )}
        onChange={(_, newValue: AutocompleteType | null) => {
          onChange(
            "orderTemplate",
            newValue || {
              value,
              ...autoCompleteDefaultValue,
            },
            isFirstRow,
          );
        }}
      />
    </OrderFormShortRowGridItem>
  );
};

export default OrderTemplateField;
